import { Grid as RadixGrid } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type GridProps = ComponentPropsWithoutRef<typeof RadixGrid>

export const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixGrid className={className} ref={ref} {...props} />
  }
)

Grid.displayName = 'Grid'
